<template>
    <div class="sticky-header-wrapper">
      <Header :title="'Консультант'" />
    </div>
  

    <transition name="fade">
        <button 
        v-if="hasChanges" 
        class="floating-save-btn" 
        @click="saveConsultantData"
        >
        Сохранить
        </button>
    </transition>

    <div class="consultant-page">
      <div class="profile-container">
        <div class="info-block-other">
            <Consultant ref="consultantRef" @consultant-changed="handleConsultantChange" />
        </div>
      </div>
    </div>
  
    <div class="sticky-footer-wrapper">
      <MiniFooter />
    </div>

    <Snackbar 
    :message="snackbarMessage" 
    :type="snackbarType" 
    :show="showSnackbar" 
    />

  </template>
  
  <script setup>
  import { ref } from 'vue'
  import Header from '../components/ProfileHeader.vue'
  import MiniFooter from '../components/MiniFooter.vue'
  import Consultant from '../components/ConsultantForProfile.vue'
  import Snackbar from '../components/Snackbar.vue'

    const snackbarMessage = ref("");
    const snackbarType = ref("success");
    const showSnackbar = ref(false);

  const hasChanges = ref(false)
  const consultantRef = ref(null)
  
  // когда Consultant что-то меняет
  const handleConsultantChange = (changed) => {
    hasChanges.value = changed
  }
  
  const saveConsultantData = async () => {
  if (consultantRef.value?.saveConsultant) {
    try {
      await consultantRef.value.saveConsultant()
      hasChanges.value = false

      snackbarMessage.value = "Изменения сохранены!";
      snackbarType.value = "success";
      showSnackbar.value = true;

      setTimeout(() => {
        showSnackbar.value = false;
      }, 3000); // ⏳ Скрываем Snackbar через 3 секунды
    } catch (error) {
      console.error("❌ Ошибка сохранения консультанта:", error);

      snackbarMessage.value = "Ошибка при сохранении. Попробуйте ещё раз!";
      snackbarType.value = "error";
      showSnackbar.value = true;

      setTimeout(() => {
        showSnackbar.value = false;
      }, 3000); // ⏳ Скрываем Snackbar через 3 секунды
    }
  }
}
  </script>
  
  <style scoped>
  .consultant-page {
    background-color: var(--profile_background-color);
    height: 100vh;
    overflow: hidden;
    padding-top: 200px; /* подвинем вниз, чтобы не прилипло к хедеру */
  }
  
  .sticky-header-wrapper {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: var(--profile_header-bg);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }
  
  .profile-container {
    height: 600px;
    position: fixed;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 900px;
    width: 90%;
    background-color: var(--profile_container-color);
    border-radius: 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
    z-index: 10;
  }
  
  .info-block-other {
    padding: 30px;
  }
  
  .sticky-footer-wrapper {
    position: sticky;
    bottom: 0;
    z-index: 90;
    background-color: var(--profile_footer-bg);
    box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  /* ⬇️ добавляем кнопку сохранить */
.floating-save-btn {
  position: fixed;
  top: 140px;
  right: calc(50% - 620px);
  background-color: #2173e5;
  color: white;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  cursor: pointer;
  z-index: 2000;
  transition: all 0.3s ease;
}

.floating-save-btn:hover {
  background-color: #195ec2;
}

html[data-theme="dark"] .btn.next:disabled {
  background: #1d4fa8 !important;
  opacity: 0.5;
}

  </style>